import PlatformActions from './PlatformActions'

export default class JJSLOTActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'SLOT',
      gameCode: '2J-SLOT-013',
      platform: 'JJ',
    }

    this.gameName = 'MERMAID\'S DANCE'
  }

  getBetMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      betTime,
      betAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `1020-0-983-${txnId}-0`, // 1020-0-983-1759287896-0
      roundId: `1020-0-983-${txnId}-0`, // 1020-0-983-1759287896-0
      betType: null,
      currency,
      betTime, // 2025-10-01T11:04:56.000+08:00
      betAmount,
      jackpotBetAmount: 0,
      gameInfo: {},
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'bet',
      txns,
    }

    return JSON.stringify(message)
  }

  getSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      updateTime,
      betTime,
      turnover,
      betAmount,
      winAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `1020-0-983-${txnId}-0`, // 1020-0-983-1759287896-0
      refPlatformTxI: null,
      settleType: 'platformTxId',
      updateTime, // 2025-10-01T11:04:56.913+08:00
      roundId: `1020-0-983-${txnId}-0`, // 1020-0-983-1759287896-0
      betType: null,
      betTime, // 2025-10-01T11:04:56.000+08:00
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      jackpotWinAmount: 0,
      gameInfo: {
        isBuy: 'false',
        freeAmount: '0',
        bonusAmount: '0',
        jackpotAmount: '0',
        extraSpins: '0',
        awardType: '0',
      },
    }))

    const message = {
      action: 'settle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: `1020-0-983-${txnId}-0`, // 1020-0-983-1759287896-0
      roundId: `1020-0-983-${txnId}-0`, // 1020-0-983-1759287896-0
      gameInfo: {},
    }))

    const message = {
      action: 'cancelBet',
      txns,
    }

    return JSON.stringify(message)
  }
}
